<template>
  <section>
    <v-container class="mt-12 overflow-hidden container-large">
      <v-row class="align-center">
        <v-col cols="12" lg="6">
          <v-img
            :src="files + item.img"
            :alt="item.title"
            max-width="100%"
          ></v-img>
        </v-col>
        <v-col cols="12" lg="6" class="d-flex justify-center">
          <v-sheet
            max-width="500px"
            class="text-center align-center d-flex flex-column"
          >
            <TitleWidget class="mb-2">{{ item.title }}</TitleWidget>
            <p>{{ item.text }}</p>
            <ButtonWidget @click="buttonLink(item.link)" class="mt-3">{{
              button_text
            }}</ButtonWidget>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import ButtonWidget from "../widgets/ButtonWidget.vue";
import TitleWidget from "../widgets/TitleWidget.vue";

//import { formatToURL } from "../../utils/formatToURL";

const _config = {
  mod: "enrollment",
};

const _data = {
  button_text: "Inscreva-se",
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
  },
  methods: {
    buttonLink(link) {
      location.href = link;
    },
  },
  created() {
    this.$rest(_config.mod).get({
      save: (state, data) => (state.item = data),
    });
  },
  components: {
    TitleWidget,
    ButtonWidget,
  },
};
</script>

<style lang="scss" scoped></style>
